// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"c99fb6aa","541":"d1748589"}[chunkId] + ".chunk.js";
};